import React, { useEffect } from "react";
import { triggerSignContractEvent } from "config/seo/events";
import { createGetServerSideProps, StaticPageProps } from "evcharging/app";
import { Page } from "containers/common/sections/layout";
import ThankYouPage from "containers/common/sections/thank-you/ThankYouPage";
import { I18nPage } from "i18n/types/pages.enum";
import { NextPage } from "next";

const ThankYou: NextPage<StaticPageProps> = ({ page }) => {
  useEffect(() => {
    triggerSignContractEvent();
  }, []);

  return (
    <Page title={page.meta_title} description={page.meta_description} locales={page.locales}>
      <ThankYouPage />
    </Page>
  );
};

export const getServerSideProps = createGetServerSideProps(undefined, undefined, [I18nPage.ThankYou]);

export default ThankYou;
